import { PssApi } from '../pss-api/pss-api.service';
export class SpecificationService extends PssApi {
    constructor() {
        super(...arguments);
        this.validate = async (data) => {
            return this.pssApi.post('/api/validate', data);
        };
        this.saveFile = async (file) => {
            const formData = new FormData();
            formData.append('content', file);
            const response = await this.pssApi.post('/file-storage/files', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return {
                ...response.data,
                url: `${this.hostUrl}${response.data.url}`
            };
        };
    }
}
//# sourceMappingURL=specification.service.js.map